import { OILSTEEL_BORDER_RADIUS, OILSTEEL_BOX_SHADOW, OILSTEEL_COLORS, OILSTEEL_FONTS, OILSTEEL_SPACING, } from '../oilsteelThemeConf';
export const oilsteelNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: OILSTEEL_BORDER_RADIUS.default,
            boxShadow: OILSTEEL_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: OILSTEEL_COLORS.success.main,
        },
        info: {
            backgroundColor: OILSTEEL_COLORS.primary.dark,
        },
        error: {
            backgroundColor: OILSTEEL_COLORS.error.main,
        },
        warning: {
            backgroundColor: OILSTEEL_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            height: OILSTEEL_FONTS.size.mediumBig,
            fontSize: OILSTEEL_FONTS.size.mediumBig,
            fontWeight: OILSTEEL_FONTS.weight.bold,
            color: OILSTEEL_COLORS.font.light,
            marginBottom: 0,
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: OILSTEEL_FONTS.size.medium,
            fontWeight: OILSTEEL_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: OILSTEEL_COLORS.font.light,
            marginTop: OILSTEEL_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=oilsteelNotificationsStyle.js.map